import CloseIcon from "@mui/icons-material/Close";
import {
  Autocomplete,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  FormControlLabel,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Loader from "../../../../components/Loader";
import { showSnackbar } from "../../../../slice/snackbarSlice";
import { updateCampaignData, xeroOptionSet } from "../../../../thunks/lookup";
import { NOTIFICATION_MESSAGE } from "../../../../utils/constant";
import AlertComponent from "../../../../components/alert";
import {
  getInternalDisbursementById,
  updateInternalDisbursement,
} from "../../../../thunks/DisPrice";

const UpdateDisbursement = ({
  open,
  handleClose,
  selectedData,
  getDisbursement = () => {},
}) => {
  const dispatch = useDispatch();
  const [isLoader, setLoader] = useState(false);
  const [isUpdateDisbursementDialog, setUpdateDisbursementDialog] =
    useState(false);
  const [isActiveDisbursement, setActiveDisbursement] = useState(false);
  const [disbursementData, setDisbursementData] = useState({
    name: "",
    isActive: true,
    isDeleted: false,
  });

  const handleChangeFormFields = (value, key) => {
    setDisbursementData({ ...disbursementData, [key]: value });
  };

  const handleOpenDisbursementDialog = () => {
    setUpdateDisbursementDialog(true);
  };

  const handleGetDisbursementById = async () => {
    try {
      setLoader(true);
      const response = await dispatch(
        getInternalDisbursementById({ id: selectedData?.id })
      ).unwrap();
      if (response) {
        setLoader(false);
        setDisbursementData({
          name: response?.name,
          isActive: response?.isActive,
          isDeleted: response?.isDeleted,
        });
      } else {
        setLoader(false);
        setDisbursementData({});
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      dispatch(
        showSnackbar({
          show: true,
          message: `${error?.message}`,
          severity: "error",
        })
      );
    }
  };

  const handleUpdateDisbursement = async () => {
    setUpdateDisbursementDialog(false);
    setActiveDisbursement(false);
    try {
      setLoader(true);
      const payload = {
        id: selectedData?.id,
        isActive: disbursementData?.isActive,
        isDeleted: disbursementData?.isDeleted,
        name: disbursementData?.name,
      };
      const response = await dispatch(
        updateInternalDisbursement(payload)
      ).unwrap();
      if (response) {
        setLoader(false);
        dispatch(
          showSnackbar({
            show: true,
            message: NOTIFICATION_MESSAGE?.INTERNAL_DISBURSEMENT_UPDATE_SUCCESS,
            severity: "success",
          })
        );
        handleClose();
        await getDisbursement();
      } else {
        setDisbursementData({});
        setLoader(false);
        setUpdateDisbursementDialog(false);
        setActiveDisbursement(false);
        handleClose();
      }
    } catch (error) {
      setDisbursementData({});
      setUpdateDisbursementDialog(false);
      setActiveDisbursement(false);
      handleClose();
      dispatch(
        showSnackbar({
          show: true,
          message: `${error?.message}`,
          severity: "error",
        })
      );
    }
  };

  const handleOpenIsActivateDialog = () => {
    setActiveDisbursement(true);
  };

  const handleActivate = () => {
    setDisbursementData((prev) => ({ ...prev, isActive: true }));
    setActiveDisbursement(false);
  };

  const handleDeactivate = () => {
    setDisbursementData((prev) => ({ ...prev, isActive: false }));
    setActiveDisbursement(false);
  };

  useEffect(() => {
    if (selectedData?.id) {
      handleGetDisbursementById();
    }
  }, [selectedData]);
  return (
    <>
      {/* Update Campaign Dialog */}
      {isUpdateDisbursementDialog && (
        <AlertComponent
          open={isUpdateDisbursementDialog}
          handleSuccess={handleUpdateDisbursement}
          handleClose={() => setUpdateDisbursementDialog(false)}
          message={"Are you sure you want to update disbursement?"}
        />
      )}

      {/* Active Disbursement Alert Dialog */}
      {isActiveDisbursement && (
        <AlertComponent
          open={isActiveDisbursement}
          handleSuccess={() =>
            disbursementData?.isActive ? handleDeactivate() : handleActivate()
          }
          handleClose={() => setActiveDisbursement(false)}
          message={`Are you sure you want to ${
            disbursementData?.isActive ? "Deactivate" : "Activate"
          } disbursement?`}
        />
      )}

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth={"sm"}
        PaperProps={{ sx: { borderRadius: "28px", paddingBottom: 0 } }}
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
        {/* Loader Component */}
        {isLoader && <Loader />}
        <DialogContent>
          <Grid container spacing={3}>
            {/* Create Task Label Section */}
            <Grid item xs={12}>
              <Typography
                className="serif_display_regular_26 green"
                textAlign={"center"}
              >
                Internal Disbursement
              </Typography>
            </Grid>

            {/* Campaign Name Field Section */}
            <Grid item xs={6}>
              <TextField
                className="inputTextField normal_normal_600_12_Manropee"
                label="Disbursement Name"
                placeholder="Disbursement Name"
                // disabled
                fullWidth
                required
                size="small"
                value={disbursementData?.name || null}
                onChange={(e) =>
                  handleChangeFormFields(e?.target?.value, "name")
                }
                // error={isError && !taskData?.name}
                // helperText={
                //   isError && !taskData?.name && VALIDATION_MSG.REQUIRED
                // }
                InputLabelProps={{ shrink: true }}
                variant="standard"
              />
            </Grid>

            {/* Is Commission Applicable? section */}
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    sx={{
                      color: "#00CE3F",
                      "&.Mui-checked": {
                        color: "#00CE3F",
                      },
                    }}
                    checked={disbursementData?.isActive || false}
                    onChange={(e) => handleOpenIsActivateDialog()}
                  />
                }
                label="Is Active?"
              />
            </Grid>

            {/* Submit Button */}
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button
                className="save_button"
                onClick={handleOpenDisbursementDialog}
              >
                Update
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default UpdateDisbursement;
